import { useApiMutation } from "@babackapp/private-api-client/client/use-api-mutation";
import { useQueryClient } from "@tanstack/react-query";

/**
 * Toggles a shop's V3 customer portal opt-in (`admin.returnWidget.enabled`)
 * from the super admin shops list. The list serves the flag live from the shop
 * document, so invalidating it is enough to reflect the new value.
 */
export function useToggleShopNewPortal(shopId: string) {
  const queryClient = useQueryClient();

  return useApiMutation("patch", "/shops/{shopId}/admin", {
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey: ["get", "/super-admin/shops"],
      }),
    mapVariables: (enabled: boolean) => ({
      params: { path: { shopId } },
      body: { returnWidget: { enabled } },
    }),
  });
}
